var map = {
	"./ar-SA/web-payments": [
		55563,
		5563
	],
	"./ar-SA/web-payments.json": [
		55563,
		5563
	],
	"./de/web-payments": [
		21308,
		1308
	],
	"./de/web-payments.json": [
		21308,
		1308
	],
	"./en/web-payments": [
		99477,
		6964
	],
	"./en/web-payments.json": [
		99477,
		6964
	],
	"./es/web-payments": [
		36134,
		6134
	],
	"./es/web-payments.json": [
		36134,
		6134
	],
	"./fr/web-payments": [
		23140,
		3140
	],
	"./fr/web-payments.json": [
		23140,
		3140
	],
	"./id/web-payments": [
		21471,
		1471
	],
	"./id/web-payments.json": [
		21471,
		1471
	],
	"./it/web-payments": [
		81784,
		1784
	],
	"./it/web-payments.json": [
		81784,
		1784
	],
	"./pt-br/web-payments": [
		27716,
		7716
	],
	"./pt-br/web-payments.json": [
		27716,
		7716
	],
	"./web-payments": [
		17101,
		7101
	],
	"./web-payments.json": [
		17101,
		7101
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 30242;
module.exports = webpackAsyncContext;